var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccessIcon = function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23A971",
    d: "M1.707 6.293A1 1 0 0 0 .293 7.707l1.414-1.414zM7 13l-.707.707a1 1 0 0 0 1.414 0L7 13zM19.707 1.707A1 1 0 0 0 18.293.293l1.414 1.414zm-19.414 6 6 6 1.414-1.414-6-6L.293 7.707zm7.414 6 12-12L18.293.293l-12 12 1.414 1.414z"
  })));
};
export default SvgSuccessIcon;